import type { Map } from 'ol'

import { RootState } from 'app/store'

import { userSelectors } from 'entities/user/model'

import { createXyzLyr } from './create-xyz-lyr'
import { createTileLyr } from './create-tile-lyr'
import { createImgLyr } from './create-img-lyr'

type Props = {
	state: RootState
	map: Map
}

export function setAutoloadLyrs({ state, map }: Props) {
	const layers = userSelectors.selectAutoloadLayers(state)

	console.log('autoload layers', { layers })

	layers.forEach((layer) => {
		let lyr: any

		if (+layer.type === 3) {
			lyr = createXyzLyr(layer, false)
		} else if (!!layer.tiled) {
			lyr = createTileLyr(layer, false)
		} else {
			lyr = createImgLyr(layer, false)
		}

		const minzoom =
			!isNaN(+layer.minzoom) && layer.minzoom - 0.5 >= 0
				? layer.minzoom - 0.5
				: layer.minzoom

		const maxzoom = !isNaN(+layer.maxzoom)
			? layer.maxzoom + 0.4999999
			: layer.maxzoom

		lyr.setMinZoom(minzoom)
		lyr.setMaxZoom(maxzoom)
		lyr.setZIndex(layer.zindex)

		lyr.setOpacity(layer.transparent ?? 0)
		lyr.setVisible(true)

		map.addLayer(lyr)
	})
}
